import React from 'react'
import Slider from "react-slick";
import styles from './Carousel.module.scss'

const Carousel = ({ carouselImages, category }) => {


    const settings = {
        dots:category==="testimonial"?false: true,
        infinite: true,
        speed: 200,
        slidesToShow: category==="testimonial"?1:1.05,
        slidesToScroll: 1,
        autoplay: category==="testimonial"?true:false,
        autoplaySpeed: 2000,
        arrows: false, 
    };


    return (
        <div>
            <Slider {...settings}>
                {
                    carouselImages.map((item, index) => (
                        category === 'testimonial' ? (
                            <div className={styles.testimonialContainer} key={index}>
                                <p>{item}</p>
                                <img src="/Patiala-Heights-Star-Img.webp" alt="Testimonial" className={styles.carouselImage}></img>
                            </div>
                        ) : (
                            <div key={index} className={styles.carouselContainer} >
                                <img src={item} alt={`Slide ${index + 1}`} className={styles.carouselImage}></img>
                            </div>
                        )
                    ))
                }
            </Slider>
        </div>
    )
}

export default Carousel